import { GetEventResponse, PostEventType } from '@orbit/api-types'
import api from '@lib/api'
import { queryKeys } from '@lib/queryKeys'
import { createTripMutation } from './createTripCrudResource'

export const useCreateEvent = createTripMutation<
	GetEventResponse,
	{ tripId: string; eventData: PostEventType }
>({
	mutationFn: async ({ tripId, eventData }) => {
		const response = await api.post<GetEventResponse>(`/trips/${tripId}/events`, eventData)
		return response.data
	},
	invalidate: ({ tripId }) => [queryKeys.events(tripId)],
})
